export const TrendingProducts  = [
    {
        id: 1,
        title: "Orchid",
        img: require("./Featuredimges/img1.jpg"),
        price:80,
        rating:3.5,
        Availability: "Pre-Order",
        reviews: 0,
        Brand: "Apple",
        ProductCode: "Product 16",
        Discount:2,
        quantity:0,
        Extax:100,
        percentEcoTax:5,
        EcoTax:2,
        details:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Possimus aspernatur magni expedita in assumenda. Maxime atque nobis tempore dolor ad quidem libero odio consequatur, nisi quasi beatae minima necessitatibus dolores."
    },
    {
        id: 2,
        title: "Anthurium",
        img: require("./Featuredimges/img2.jpg"),
        price:30.7,
        rating:2,
        Availability: "Pre-Order",
        reviews: 0,
        Brand: "Apple",
        ProductCode: "Product 16",
        Discount:2,
        quantity:0,
        Extax:100,
        percentEcoTax:5,
        EcoTax:4,
        details:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Possimus aspernatur magni expedita in assumenda. Maxime atque nobis tempore dolor ad quidem libero odio consequatur, nisi quasi beatae minima necessitatibus dolores."
    },
    {
        id: 3,
        title: "Spider plant",
        img: require("./Featuredimges/img3.jpg"),
        price:90,
        rating:3.5,
        Availability: "inStock",
        reviews: 0,
        Brand: "Apple",
        ProductCode: "Product 16",
        Discount:2,
        quantity:0,
        Extax:100,
        percentEcoTax:5,
        EcoTax:2,
        details:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Possimus aspernatur magni expedita in assumenda. Maxime atque nobis tempore dolor ad quidem libero odio consequatur, nisi quasi beatae minima necessitatibus dolores."
    },
    {
        id: 4,
        title: "Succulents",
        img: require("./Featuredimges/img4.jpg"),
        price:90,
        rating:5,
        Availability: "inStock",
        reviews: 7,
        Brand: "Apple",
        ProductCode: "Product 16",
        Discount:2,
        quantity:0,
        Extax:100,
        percentEcoTax:5,
        EcoTax:2,
        details:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Possimus aspernatur magni expedita in assumenda. Maxime atque nobis tempore dolor ad quidem libero odio consequatur, nisi quasi beatae minima necessitatibus dolores."
    },
    {
        id: 5,
        title: "Snake plant",
        img: require("./Featuredimges/img5.jpg"),
        price:55,
        rating:2.5,
        Availability: "inStock",
        reviews: 5,
        Brand: "Apple",
        ProductCode: "Product 16",
        Discount:2,
        quantity:0,
        Extax:100,
        percentEcoTax:5,
        EcoTax:4,
        details:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Possimus aspernatur magni expedita in assumenda. Maxime atque nobis tempore dolor ad quidem libero odio consequatur, nisi quasi beatae minima necessitatibus dolores."
    },
    {
        id: 6,
        title: "Cactus",
        img: require("./Featuredimges/img6.jpg"),
        price:30,
        rating:5,
        Availability: "inStock",
        reviews: 0,
        Brand: "Apple",
        ProductCode: "Product 16",
        Discount:2,
        quantity:0,
        Extax:100,
        percentEcoTax:5,
        EcoTax:3,
        details:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Possimus aspernatur magni expedita in assumenda. Maxime atque nobis tempore dolor ad quidem libero odio consequatur, nisi quasi beatae minima necessitatibus dolores."
    },
    {
        id: 7,
        title: "Air plant",
        img: require("./Featuredimges/img7.jpg"),
        price:90,
        rating:5,
        Availability: "inStock",
        reviews: 4.5,
        Brand: "Apple",
        ProductCode: "Product 16",
        Discount:2,
        quantity:0,
        Extax:100,
        percentEcoTax:5,
        EcoTax:1,
        details:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Possimus aspernatur magni expedita in assumenda. Maxime atque nobis tempore dolor ad quidem libero odio consequatur, nisi quasi beatae minima necessitatibus dolores."
    },
    {
        id: 8,
        title: "Dragon Tree",
        img: require("./Featuredimges/img8.jpg"),
        price:25,
        rating:1.5,
        Availability: "inStock",
        reviews: 0,
        Brand: "Apple",
        ProductCode: "Product 16",
        Discount:2,
        quantity:0,
        Extax:100,
        percentEcoTax:5,
        EcoTax:2,
        details:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Possimus aspernatur magni expedita in assumenda. Maxime atque nobis tempore dolor ad quidem libero odio consequatur, nisi quasi beatae minima necessitatibus dolores."
    },
    {
        id: 9,
        title: "Anthurium",
        img: require("./Featuredimges/img9.jpg"),
        price:90,
        rating:3.5,
        Availability: "inStock",
        reviews: 0,
        Brand: "Apple",
        ProductCode: "Product 16",
        Discount:2,
        quantity:0,
        Extax:100,
        percentEcoTax:5,
        EcoTax:5,
        details:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Possimus aspernatur magni expedita in assumenda. Maxime atque nobis tempore dolor ad quidem libero odio consequatur, nisi quasi beatae minima necessitatibus dolores."
    },
    {
        id: 10,
        title: "SCactus",
        img: require("./Featuredimges/img10.jpg"),
        price:10.5,
        rating:5,
        Availability: "inStock",
        reviews: 0,
        Brand: "Apple",
        ProductCode: "Product 16",
        Discount:2,
        quantity:0,
        Extax:100,
        percentEcoTax:5,
        EcoTax:3,
        details:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Possimus aspernatur magni expedita in assumenda. Maxime atque nobis tempore dolor ad quidem libero odio consequatur, nisi quasi beatae minima necessitatibus dolores."
    },
]